import React, { useContext } from "react";
import { languageKey } from "../../../constants/static";
import { copyrightInfringementURL } from "../../../constants/urls";
import { StateContext } from "../../../context/stateContext";
import { useFetch } from "../../../hooks/useFetch";
import { IURLAssetReference } from "../../../interfaces/urlAssetReference";
import { translations } from "../../../translate";
import utils from "../../../utils/helperFunction";
import ParentFragmentHTML from "../../lib/ParentFragmentHTML";
import LegalAndPrivacyContainer from "../legalAndPrivacyContainer/LegalAndPrivacyContainer";

const CopyrightInfringementNotification = () => {
  const { stateUSACode, cidmUrl, languageCode } = useContext(StateContext);
  const { getStateName } = utils;
  const URL = `${cidmUrl}${copyrightInfringementURL}/${getStateName(
    stateUSACode
  )}&experience/language/${languageCode}&content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${
    languageKey[languageCode]
  }/${getStateName(stateUSACode)}-general/registration/unauthenticated/copyright-infringement-notification`;
  const { data, loading } = useFetch<{ urlAssetReferences: IURLAssetReference[] }>(cidmUrl ? URL : "");

  return (
    <LegalAndPrivacyContainer title={translations.copyInfNotif[languageCode]}>
      {!loading && <ParentFragmentHTML data={data?.urlAssetReferences} />}
    </LegalAndPrivacyContainer>
  );
};

export default CopyrightInfringementNotification;
